module.exports = __webpack_public_path__ + "img/D7.fcbb5751.png";